export const TOKEN_LOCAL_STORAGE_KEY = 'token';
export const VERIFIER_SESSION_STORAGE_KEY = 'pkce_code_verifier';
export const ORG_HEADER_NAME = 'x-org-id';
export const RETURN_TO_STORAGE_KEY = 'auth_return_to';
